var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartPie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.79434 6.71944C8.78878 5.9275 9.98662 5.43245 11.25 5.29126V12.75H18.7088C18.5676 14.0134 18.0725 15.2112 17.2806 16.2057C16.4886 17.2001 15.432 17.9507 14.2323 18.3712C13.0326 18.7916 11.7385 18.8647 10.4991 18.5821C9.25964 18.2995 8.12518 17.6727 7.22627 16.7737C6.32736 15.8748 5.70054 14.7404 5.41794 13.5009C5.13534 12.2615 5.20845 10.9674 5.62886 9.76773C6.04928 8.56801 6.7999 7.51137 7.79434 6.71944Z",
    stroke: "#3F3F46",
    strokeOpacity: 0.86,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 9.75003H18.366C18.0293 8.801 17.4851 7.93904 16.773 7.22699C16.061 6.51494 15.199 5.97073 14.25 5.63403V9.75003Z",
    stroke: "#3F3F46",
    strokeOpacity: 0.86,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartPie);
export default __webpack_public_path__ + "static/media/Chart-pie.4e86f78a3970fe559c7b4a25d8af9767.svg";
export { ForwardRef as ReactComponent };